var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInProcess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168082",
    "data-name": "Group 168082",
    transform: "translate(-314 -480)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168005",
    "data-name": "Path 168005",
    d: "M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z",
    transform: "translate(314 480)",
    fill: "#e89922"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-timer",
    "data-name": "Icon ionic-ios-timer",
    transform: "translate(312.514 478.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168007",
    "data-name": "Path 168007",
    d: "M11.488,19.039A7.551,7.551,0,0,1,6.248,6.052a.606.606,0,1,1,.842.872,6.337,6.337,0,1,0,5-1.744V7.543a.608.608,0,1,1-1.216,0v-3a.607.607,0,0,1,.608-.608,7.551,7.551,0,0,1,0,15.1Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168008",
    "data-name": "Path 168008",
    d: "M11.851,11.323l3.756,2.7a1.137,1.137,0,1,1-1.321,1.85,1.1,1.1,0,0,1-.264-.264l-2.7-3.756a.379.379,0,0,1,.529-.529Z",
    transform: "translate(-3.387 -3.387)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProcess);
export default __webpack_public_path__ + "static/media/in-process.9273b5ba90e986adb5755a7a2cdfe6f5.svg";
export { ForwardRef as ReactComponent };